export const SITE_URL = "https://parfimerija-duro.me";
export const SITE_NAME = "DURŌ Niche perfumery";
export const SITE_LOGO = `${SITE_URL}/assets/images/favicon/icon.svg`;
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/images/favicon/og-image.jpg`;
